<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid"/> Cancelled Health Policies
      </CCardHeader>
      <PoliciesTable />
    </CCard> 
  </div>
</template>

<script>
import PoliciesTable from "@/components/CancelledHealthTable"
export default {
  components:{
    PoliciesTable
  }
}
</script>

<style>

</style>